import {AdminRuntimeOverridableKey} from '../types/AdminRuntimeOverridableKey'

export const AdminRuntimeOverridableKeys = [
  'ApiHost',
  'SocketIoHost',
  'SocketIoPath',
  'WebAssetsHost',
  'ClientHost',
  'InternalLinkHosts',
  'LiveKitUrl',
  'GoogleAccessToken',
  'PublicMapboxAccessToken',
  'RecaptchaSiteKey',
  'SentryDsn',
  'EnvironmentName',
  'ShouldShowEnvRibbon',
  'shouldRequestCompression',
  'DisableCaptcha',
] as const satisfies ReadonlyArray<AdminRuntimeOverridableKey>
